import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';
import { useInjectReducer } from 'utils/redux-injectors';
import { State } from './types';
import { endpoints, baseQuery } from 'utils/api/endpoints';

export const initialState: State = {};

const slice = createSlice({
  name: 'usersApi',
  initialState,
  reducers: {
    someAction(state, action: PayloadAction<any>) {},
  },
});

export const api = createApi({
  reducerPath: 'usersApi',
  tagTypes: ['user', 'usersList'],
  baseQuery,
  endpoints: builder => ({
    getUsers: builder.query<any, any>({
      query: filters => ({
        url: endpoints.USERS,
        method: 'GET',
        params: filters,
      }),
      providesTags: ['user', 'usersList'],
    }),

    getUserStats: builder.query<any, void>({
      query: () => ({
        url: `${endpoints.USERS}/stats`,
        method: 'GET',
      }),
    }),

    checkUsenameOrEmail: builder.mutation<any, any>({
      query: body => ({
        url: endpoints.USERS + '/check-username-email',
        method: 'POST',
        body,
      }),
    }),
    addUser: builder.mutation({
      query: data => ({
        url: endpoints.USERS + '/add',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['user'],
    }),
    updateProfile: builder.mutation({
      query: data => ({
        url: endpoints.USERS + '/update-profile',
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['user'],
    }),

    getSeachUsers: builder.query<any, any>({
      query: params => ({
        url: endpoints.USERS,
        method: 'GET',
        params: {
          ...params,
          type: 'search',
        },
      }),
    }),
  }),
});

export const { actions: UsersActions } = slice;

export const useUserSlice = () => {
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  //  useInjectSaga({ key: slice.name, saga: Saga });
  return {
    actions: UsersActions,
    useGetUsersQuery: api.useLazyGetUsersQuery,
    useGetUserStatsQuery: api.useGetUserStatsQuery,
    useAddUserMutation: api.useAddUserMutation,
    useCheckUsernameOrEmailMutation: api.useCheckUsenameOrEmailMutation,
    useGetSeachUsersQuery: api.useLazyGetSeachUsersQuery,
  };
};
